import { TICKET_CLASS } from "constants/ticketClass";

import type { TicketClass } from "constants/ticketClass";

const TICKET_CLASS_VALUES = Object.values(TICKET_CLASS);

export const getTicketClass = (
  maybeTicketClass: number | undefined
): TicketClass => {
  const maybeFound = TICKET_CLASS_VALUES.find(
    (value) => value === maybeTicketClass
  );
  return maybeFound ?? TICKET_CLASS.VENUE;
};
